// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"42005477","151":"3602aa9b","314":"2f167582","718":"d577f8ab","925":"4ded66ae","953":"24493336"}[chunkId] + ".chunk.css";
};